import Toast from './Index.vue'
import { DEVICE_TYPE_ANDROID, DEVICE_TYPE_IOS } from '@/common/devicetype.const'

export default {
  install (Vue) {
    let CONSTRUCTOR = Vue.extend(Toast)

    function toast ({ message = '', device = 'mobile' }) {
      // eslint-disable-next-line new-parens
      let toastObject = new CONSTRUCTOR
      let vm
      if (device === 'mobile') {
        if (!toastObject.$el) {
          vm = toastObject.$mount()
          document.querySelector('body').appendChild(vm.$el)
        }
        toastObject.queue.push(message)
      } else if (device === DEVICE_TYPE_IOS) {
        window.webkit.messageHandlers.showToast.postMessage(message)
      } else if (device === DEVICE_TYPE_ANDROID) {
        window.Android.showToast(message)
      }
    }

    // eslint-disable-next-line
    Vue.toast = Vue.prototype.$toast = toast;
  }
}
